import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { AgmCoreModule } from '@agm/core';
import { Ng2Webstorage } from 'ngx-webstorage';

import { MatInputModule, MatFormField, MatSelect, MatSelectModule, MatChipsModule, MatCheckboxModule } from '@angular/material';

import { ChartsModule } from 'ng2-charts';

import { GooglePieChartService } from './GCharts/GooglePieChartService';

//grid
import { AgGridModule } from 'ag-grid-angular';

import {GalleriaModule} from 'primeng/galleria';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CompaniaComponent } from './compania/compania.component';
import { MenuComponent } from './menu/menu.component';
import { VehiculoComponent } from './vehiculo/vehiculo.component';
import { UsuarioComponent } from './usuario/usuario.component';
import { ZonaComponent } from './zona/zona.component';
import { RutaComponent } from './ruta/ruta.component';
import { PuntoVisitaComponent } from './punto-visita/punto-visita.component'
import { VisitaComponent } from './visita/visita.component';


import { UtilesService } from './services/utiles.service';
import { CompaniaService } from './services/compania.service';
import { VehiculoService } from './services/vehiculo.service';
import { GlobalsService } from './services/globals.service';
import { UsuarioService } from './services/usuario.service';
import { ZonaService } from './services/zona.service';
import { RutaService } from './services/ruta.service';
import { GeolocationService } from './services/geolocation.service';
import { PuntoVisitaService } from './services/punto-visita.service';
import { VisitaService } from './services/visita.service';

import { ViajeService } from './services/viaje.service';
import { ViajeRecorridoService } from './services/viaje-recorrido.service';
import { ReporteViajeService } from './services/reporte-viaje.service';
import { ReportePuntoVisitaService } from './services/reporte-punto-visita.service';
import { ReglaService } from './services/regla.service';
import { GeneradorTemplateService } from './services/generador-template.service';
import { MedicionService } from './services/medicion.service';
import { MotivoService } from './services/motivo.service';
import { CorreoService } from './services/correo.service';
import { VisitaCertificacionService } from './services/visita-certificacion.service';
import { VisitaTareaService } from './services/visita-tarea.service';
import { IndicadorService } from './services/indicador.service';


import { AdminLayoutComponent } from './admin-layout/admin-layout.component';
import { SeguridadLayoutComponent } from './seguridad-layout/seguridad-layout.component';
import { LoginComponent } from './login/login.component';

import { ViajeComponent } from './viaje/viaje.component';

import { IncioComponent } from './incio/incio.component';
import { PieChartComponentComponent } from './GCharts/pie-chart-component/pie-chart-component.component';

//calendario
import { CalendarioComponent } from './calendario/calendario.component';
import { FullCalendarModule } from 'ng-fullcalendar';
import { CalendarioService } from './services/calendario.service';

//import { ReporteViajeComponent } from './reporte-viaje/reporte-viaje.component';
import { ReporteviajeComponent } from './reporteviaje/reporteviaje.component';
import { ReportePuntoVisitaComponent } from './reporte-punto-visita/reporte-punto-visita.component';
import { ActualizarPuntoVisitaComponent } from './actualizar-punto-visita/actualizar-punto-visita.component';
import { CorreoClienteLayoutComponent } from './correo-cliente-layout/correo-cliente-layout.component';
import { ReporteCertificacionClienteComponent } from './reporte-certificacion-cliente/reporte-certificacion-cliente.component'

import { VisitaTareaSerieComponent } from "./visita-tarea-serie/visita-tarea-serie.component";
import { VisitaTareaComponent  } from "./visita-tarea/visita-tarea.component";

import {Routes, RouterModule} from "@angular/router";
import { Router, ActivatedRoute} from "@angular/router";
import { ReporteErrorComponent } from './reporte-error/reporte-error.component';
import { ReporteErrorService } from './services/reporte-error.service';
import { ReporteFacturacionComponent } from './reporte-facturacion/reporte-facturacion.component';
import { CerrarViajeForzadoComponent } from './cerrar-viaje-forzado/cerrar-viaje-forzado.component';
import { ReporteGaleriaComponent } from './reporte-galeria/reporte-galeria.component';


import 'hammerjs';
import 'mousetrap';
import { ModalGalleryModule } from 'angular-modal-gallery';
import { ReglasComponent } from './reglas/reglas.component';
import { ReporteViajeContenedorComponent } from './reporte-viaje-contenedor/reporte-viaje-contenedor.component';
import { ReportePuntoVisitaDistanciaComponent } from './reporte-punto-visita-distancia/reporte-punto-visita-distancia.component';
import { ReportePagoComponent } from './reporte-pago/reporte-pago.component';
import { ReporteViajeReciboConformeComponent } from './reporte-viaje-recibo-conforme/reporte-viaje-recibo-conforme.component';
import { MedicionComponent } from './medicion/medicion.component';
import { ReportePagosEfectuadosComponent } from './reporte-pagos-efectuados/reporte-pagos-efectuados.component';
import { ReporteDevolucionesComponent } from './reporte-devoluciones/reporte-devoluciones.component';
import { ReporteMedicionVehiculoComponent } from './reporte-medicion-vehiculo/reporte-medicion-vehiculo.component';
import { MotivoComponent } from './motivo/motivo.component';
import { CorreoComponent } from './correo/correo.component';
import { TrasladoMercaderiaComponent } from './traslado-mercaderia/traslado-mercaderia.component';
import { ImportarExcelComponent } from './importar-excel/importar-excel.component';
import { ReporteDevolucionLibreComponent } from './reporte-devolucion-libre/reporte-devolucion-libre.component';
import { IndicadorVisitaClienteComponent } from './indicador-visita-cliente/indicador-visita-cliente.component';
import { IndicadorEntregaChoferComponent } from './indicador-entrega-chofer/indicador-entrega-chofer.component';
import { IndicadorFacturasChoferComponent } from './indicador-facturas-chofer/indicador-facturas-chofer.component';
import { IndicadorProporcionEntregaComponent } from './indicador-proporcion-entrega/indicador-proporcion-entrega.component';


@NgModule({
  declarations: [
    AppComponent,
    CompaniaComponent,
    MenuComponent,
    VehiculoComponent,
    UsuarioComponent,
    ZonaComponent,
    RutaComponent,
    PuntoVisitaComponent,
    VisitaComponent,
    AdminLayoutComponent,
    SeguridadLayoutComponent,
    LoginComponent,
    ViajeComponent,
    IncioComponent,
    PieChartComponentComponent,
    PieChartComponentComponent,
    CalendarioComponent,
    ReporteviajeComponent,
    ReportePuntoVisitaComponent,
    ActualizarPuntoVisitaComponent,
    CorreoClienteLayoutComponent,
    ReporteCertificacionClienteComponent,
    VisitaTareaSerieComponent,
    VisitaTareaComponent,
    ReporteErrorComponent,
    ReporteFacturacionComponent,
    CerrarViajeForzadoComponent,
    ReporteGaleriaComponent,
    ReglasComponent,
    ReporteViajeContenedorComponent,
    ReportePuntoVisitaDistanciaComponent,
    ReportePagoComponent,
    ReporteViajeReciboConformeComponent,
    MedicionComponent,
    ReportePagosEfectuadosComponent,
    ReporteDevolucionesComponent,
    ReporteMedicionVehiculoComponent,
    MotivoComponent,
    CorreoComponent,
    TrasladoMercaderiaComponent,
    ImportarExcelComponent,
    ReporteDevolucionLibreComponent,
    IndicadorVisitaClienteComponent,
    IndicadorEntregaChoferComponent,
    IndicadorFacturasChoferComponent,
    IndicadorProporcionEntregaComponent,
    
    //ReporteViajeComponent,
   // ReporteViajeComponent,




  ],
  imports: [
    ChartsModule,
    BrowserModule,
    Ng2Webstorage,
    FormsModule,
    HttpModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MatInputModule,
    MatSelectModule,
    MatChipsModule,
    FullCalendarModule,
    MatCheckboxModule,
    AgGridModule.withComponents([]),
    GalleriaModule,
    ModalGalleryModule.forRoot()
  ],
  providers:
    [
      GooglePieChartService,
      GlobalsService,
      CompaniaService,
      UtilesService,
      VehiculoService,
      UsuarioService,
      ZonaService,
      RutaService,
      GeolocationService,
      PuntoVisitaService,
      VisitaService,
      ViajeService,
      ViajeRecorridoService,
      CalendarioService,
      ReporteViajeService,
      ReportePuntoVisitaService,
      ReporteErrorService,
      ReglaService,
      GeneradorTemplateService,
      MedicionService,
      MotivoService,
      CorreoService,
      VisitaCertificacionService,
      VisitaTareaService,
      IndicadorService
    ],
  bootstrap: [AppComponent]
})
export class AppModule { }
